module.exports = __webpack_public_path__ + "u9.no2.ed2b1678.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u9.no2.jpg
// module id = z5Xg
// module chunks = 0